module.exports = __webpack_public_path__ + "static/media/fee.5058d6a8.svg";